import { render } from "./EnvioForm.vue?vue&type=template&id=4f2e6562"
import script from "./EnvioForm.vue?vue&type=script&lang=js"
export * from "./EnvioForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__